/*
 * CHATHEADER COMPONENT
 *
 * RENDERS THE HEADER BAR FOR THE CHAT WINDOW, INCLUDING TITLE, LOGO, AND MINIMIZE BUTTON.
 * CALLS onClose WHEN THE MINIMIZE ICON IS CLICKED.
 * ADDS ERROR HANDLING AROUND THE onClose CALLBACK AND IMAGE LOADING.
 */

import React from "react";
import PropTypes from "prop-types";
import styles from "./ChatHeader.module.scss";

const ChatHeader = ({ onClose }) => {
  // Safe wrapper around your onClose prop
  const handleClose = () => {
    try {
      onClose();
    } catch (err) {
      console.error("Error in ChatHeader onClose:", err);
    }
  };

  // Hide an icon if its SVG fails to load
  const handleImgError = e => {
    e.currentTarget.style.display = "none";
    console.warn("ChatHeader icon failed to load:", e.currentTarget.src);
  };

  return (
    <div className={styles.header}>
      <div className={styles.textContainer}>
        <span className={styles.title}>Prata med</span>
        <img
          src="/assets/b_svg_l.svg"
          alt="Borago"
          className={styles.logo}
          onError={handleImgError}
        />
      </div>

      <button
        className={styles.minimizeButton}
        onClick={handleClose}
        aria-label="Minimera chat"
      >
        <img
          src="/assets/down-arrow.svg"
          alt="Minimize"
          className={styles.arrow}
          onError={handleImgError}
        />
      </button>
    </div>
  );
};

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

ChatHeader.defaultProps = {
  onClose: () => {},
};

export default ChatHeader;
